import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import TrustContent from '@/components/feature/TrustContent';
import { useJsonLd } from '@/hooks/useJsonLd';
import { editorialPage } from '@/mocks/trustPages';

export default function EditorialPage() {
  const { i18n } = useTranslation();
  const lang = editorialPage[i18n.language] ? i18n.language : 'en';
  const page = editorialPage[lang];

  useJsonLd({
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: page.title,
    description: page.metaDescription,
    url: `${import.meta.env.VITE_SITE_URL}/editorial-policy`,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <TrustContent page={page} />
      </main>
      <Footer />
    </div>
  );
}